var map = {
	"./icon1.png": 8117,
	"./icon2.png": 1390,
	"./icon3.png": 7175,
	"./icon4.png": 7560,
	"./icon5.png": 5953,
	"./icon6.png": 9706,
	"./icon7.png": 1920,
	"./sample1.png": 5354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5601;